import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import loadjs from "loadjs";
import { useDispatch } from "react-redux";
import auth from "../services/authService";
import MenuItem from "../comman/MenuItem";
import { resolveActiveLeftMenuPath } from "../app/Layout/Private/leftMenuBreadcrumbs";
import { loadRolePermission, loadUserDetails } from "../app/store/auth";

const Menu = ({ isCollapsed, onToggleCollapse, onClickToggle }) => {
  const [currentUser, setCurrentUser] = useState("");
  const [user, setUser] = useState("");
  const [isSelected, setIsSelected] = useState("");
  const [rolePermission, setRolePermission] = useState([]);
  const [isHoverExpanded, setIsHoverExpanded] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const activeMenuPath = resolveActiveLeftMenuPath(location.pathname, location.state);

  useEffect(() => {
    const loadUserData = async () => {
      const loggedInUser = auth.getCurrentUser();
      if (loggedInUser === null || loggedInUser === undefined) {
        window.location = "/Login";
        return;
      }
      setUser(loggedInUser);

      const details = await dispatch(loadUserDetails(loggedInUser.id));
      if (!details) return;
      setCurrentUser(details);

      if (loggedInUser.type !== "admin") {
        const permission = await dispatch(loadRolePermission(details.roleId));
        setRolePermission(permission);
      }
    };
    loadUserData();
  }, [dispatch]);

  const handleLinkClick = () => {
    onClickToggle(false);
  };

  const handleClick = (e) => {
    setIsSelected(e.currentTarget.id);
  };

  const checkMenuPermission = (mid) => {
    if (!rolePermission) return;
    const loggedInUser = auth.getCurrentUser();
    if (loggedInUser.type === "admin") return true;
    const mm = mid.split("_");
    let chk = false;
    if (mm[0] === "m") {
      const mR = rolePermission.filter(
        (x) => x.id === parseInt(mm[1]) && x.isChecked === true
      );
      if (mR.length > 0) {
        chk = true;
      } else {
        rolePermission.filter((x) => x.id === parseInt(mm[1]))
          .map((menu) => {
            const sMenu = menu.menus.filter((x) => x.isChecked === true);
            if (sMenu.length > 0) {
              chk = true;
            } else {
              menu.menus.map((ssmenu) => {
                if (ssmenu?.menus) {
                  const ssMenu = ssmenu.menus.filter(
                    (x) => x.isChecked === true
                  );
                  if (ssMenu.length > 0) {
                    chk = true;
                  }
                }
              });
            }
          });
      }
    }
    if (mm[0] === "sm") {
      rolePermission
        .filter((x) => x.id === parseInt(mm[2]))
        .map((menu) => {
          const sMenu = menu.menus.filter(
            (x) => x.id === parseInt(mm[1]) && x.isChecked === true
          );
          if (sMenu.length > 0) {
            chk = true;
          } else {
            menu.menus.map((smenu) => {
              if (smenu?.menus) {
                const ssMenu = smenu.menus.filter((x) => x.isChecked === true);
                if (ssMenu.length > 0) {
                  chk = true;
                }
              } else {
                if (smenu?.isChecked) {
                  chk = true;
                }
              }
            });
          }
        });
    }
    if (mm[0] === "ssm") {
      rolePermission
        .filter((x) => x.id === parseInt(mm[3]))
        .map((menu) =>
          menu.menus
            .filter((x) => x.id === parseInt(mm[2]))
            .map((ssmenu) => {
              if (ssmenu?.menus) {
                const ssMenu = ssmenu.menus.filter(
                  (x) => x.id === parseInt(mm[1]) && x.isChecked === true
                );
                if (ssMenu.length > 0) {
                  chk = true;
                }
              } else {
                if (ssmenu?.isChecked) chk = true;
              }
            })
        );
    }
    return chk;
  };

  const isCollapsedRail = isCollapsed && !isHoverExpanded;
  const isEffectivelyExpanded = !isCollapsedRail;

  let loggedUser = user ? { ...user } : "";
  if (
    loggedUser &&
    loggedUser.type !== "admin" &&
    currentUser.roleType === "Complete Application Ownership"
  ) {
    loggedUser.type = "admin";
  }

  return (
    <nav
      className="sidenav navbar navbar-vertical fixed-left navbar-expand-xs navbar-light bg-white shadow-none"
      id="sidenav-main"
      data-collapsed={isCollapsedRail ? "true" : "false"}
      data-hovered={isHoverExpanded ? "true" : "false"}
      onMouseEnter={() => {
        if (isCollapsed) setIsHoverExpanded(true);
      }}
      onMouseLeave={() => {
        if (isCollapsed) setIsHoverExpanded(false);
      }}
    >
      <style>{`
        #sidenav-main {
          background: #ffffff !important;
          border-right: 1px solid rgba(203, 213, 225, 0.8) !important;
          box-shadow: 4px 0 16px rgba(15, 23, 42, 0.08) !important;
          overflow: hidden !important;
          overflow-y: hidden !important;
          transform: none !important;
        }
        #sidenav-main::-webkit-scrollbar {
          display: none !important;
          width: 0 !important;
          height: 0 !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"],
        #sidenav-main[data-collapsed="true"][data-hovered="false"]:hover,
        #sidenav-main[data-collapsed="true"][data-hovered="false"]:focus,
        #sidenav-main[data-collapsed="true"][data-hovered="false"]:focus-within {
          width: 120px !important;
          min-width: 120px !important;
          max-width: 120px !important;
          transform: none !important;
          z-index: 1020 !important;
        }

        #sidenav-main[data-collapsed="false"] {
          width: 230px !important;
          min-width: 230px !important;
          max-width: 230px !important;
          z-index: 1020 !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="true"] {
          width: 230px !important;
          min-width: 230px !important;
          max-width: 230px !important;
          z-index: 1040 !important;
          background: #ffffff !important;
          box-shadow: 16px 0 36px rgba(15, 23, 42, 0.22) !important;
        }

        #sidenav-main[data-collapsed="false"] .navbar-brand {
          display: flex !important;
          align-items: center;
          justify-content: flex-start;
          width: auto;
        }

        #sidenav-main[data-collapsed="false"] .sidenav-header {
          flex-direction: row;
          align-items: center !important;
          justify-content: space-between;
          gap: 0;
          padding-bottom: 0px;
        }

        #sidenav-main[data-collapsed="false"] .ml-auto {
          margin-left: auto !important;
          width: auto;
          display: block;
        }

        #sidenav-main[data-collapsed="false"] .premium-sidebar-heading {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          max-width: none;
        }

        #sidenav-main[data-collapsed="false"] .premium-sidebar-heading i {
          margin-right: 0.5rem !important;
        }

        #sidenav-main .scrollbar-inner {
          height: 100%;
          overflow-y: auto !important;
          overflow-x: hidden;
          padding: 14px 10px 18px 10px;
          scrollbar-width: thin;
          scrollbar-color: #94a3b8 #f1f5f9;
        }
        #sidenav-main .scrollbar-inner::-webkit-scrollbar {
          width: 8px !important;
          height: 8px !important;
        }
        #sidenav-main .scrollbar-inner::-webkit-scrollbar-track {
          background: #f1f5f9 !important;
          border-radius: 999px !important;
        }
        #sidenav-main .scrollbar-inner::-webkit-scrollbar-thumb {
          background: linear-gradient(180deg, #cbd5e1 0%, #94a3b8 100%) !important;
          border-radius: 999px !important;
          border: 2px solid #f1f5f9 !important;
        }
        #sidenav-main .scrollbar-inner::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(180deg, #94a3b8 0%, #64748b 100%) !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .scrollbar-inner {
          padding-left: 12px;
          padding-right: 12px;
        }

        #sidenav-main .navbar-nav {
          gap: 0px;
        }

        #sidenav-main .nav.nav-sm {
          border-left: none !important;
          margin-left: 12px !important;
          padding-left: 0 !important;
        }

        #sidenav-main .nav.nav-sm .nav-link {
          margin-left: 0 !important;
          margin-right: 0 !important;
          padding: 7px 10px !important;
          font-size: 14px !important;
          font-weight: 500 !important;
          color: #1e293b !important;
          gap: 8px !important;
        }

        #sidenav-main .nav.nav-sm .nav-link:hover,
        #sidenav-main .nav.nav-sm .nav-link.active {
          color: #0f172a !important;
          font-weight: 500 !important;
        }

        #sidenav-main .nav.nav-sm .nav-link .nav-link-text {
          color: #1e293b !important;
          font-weight: 500 !important;
        }

        #sidenav-main .nav.nav-sm .nav-link:hover .nav-link-text,
        #sidenav-main .nav.nav-sm .nav-link.active .nav-link-text {
          color: #0f172a !important;
          font-weight: 500 !important;
        }

        #sidenav-main .nav.nav-sm .nav-link i {
          color: #1e293b !important;
        }

        #sidenav-main .nav.nav-sm .nav-link:hover i,
        #sidenav-main .nav.nav-sm .nav-link.active i {
          color: #0f172a !important;
        }

        #sidenav-main.navbar-light .navbar-nav .nav-link,
        #sidenav-main.navbar-light .navbar-nav .nav .nav-link,
        #sidenav-main .navbar-nav .nav .nav-link {
          color: #1e293b !important;
          font-weight: 500 !important;
        }

        #sidenav-main .nav-link[data-toggle="collapse"]::after,
        #sidenav-main .nav-link[aria-expanded]::after,
        #sidenav-main .nav-link::after {
          display: none !important;
          content: none !important;
        }

        #sidenav-main .nav-item {
          margin-bottom: 0px;
        }

        #sidenav-main .premium-sidebar-heading {
          background: linear-gradient(180deg, #ffffff 0%, #f5f5f5 100%) !important;
          border: 1px solid #d4d4d4 !important;
          border-radius: 9px !important;
          font-size: 14px;
          font-weight: 500;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          color: #1e293b !important;
          box-shadow: none;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          max-width: none;
        }

        #sidenav-main .premium-sidebar-heading i {
          color: #1e293b !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .premium-sidebar-heading {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 11px 8px !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .premium-sidebar-heading i {
          margin-right: 0 !important;
        }

        #sidenav-main .collapse.show {
          margin-top: 0px;
        }

        #sidenav-main .nav-link {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          gap: 12px;
          width: 100%;
          box-sizing: border-box;
          min-height: 42px;
          padding: 10px 12px !important;
          border-radius: 12px !important;
          font-size: 14px;
          font-weight: 500;
          color: #1e293b !important;
          transition: background-color 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease;
        }

        #sidenav-main .nav-link i {
          color: #1e293b !important;
        }

        #sidenav-main .nav-link:hover {
          background: #f5f5f5 !important;
          box-shadow: inset 0 0 0 1px #e5e5e5 !important;
          border-radius: 12px !important;
          transform: none !important;
          text-decoration: none !important;
          color: #0f172a !important;
          font-weight: 500 !important;
        }

        #sidenav-main .nav-link:hover i {
          color: #0f172a !important;
        }

        #sidenav-main .menu-parent-link,
        #sidenav-main .menu-parent-link:hover {
          background: transparent !important;
          box-shadow: none !important;
          color: #1e293b !important;
          font-weight: 500 !important;
          font-size: 14px !important;
          gap: 8px !important;
          cursor: default !important;
          pointer-events: none !important;
          transform: none !important;
        }

        #sidenav-main .menu-parent-link i {
          color: #1e293b !important;
        }

        #sidenav-main .nav-link.active {
          background: #f5f5f5 !important;
          color: #0f172a !important;
          font-weight: 500 !important;
          border-radius: 12px !important;
          box-shadow: inset 3.5px 0 0 #171717 !important;
          padding-left: 24px !important;
        }

        #sidenav-main .nav-link.active i {
          color: #0f172a !important;
          margin-left: 3.5px !important;
        }

        #sidenav-main .nav-link.active .nav-link-text {
          color: #0f172a !important;
          font-weight: 500 !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-link {
          justify-content: center;
          padding-left: 10px !important;
          padding-right: 10px !important;
          min-height: 56px;
        }

        #sidenav-main[data-collapsed="false"] .nav.nav-sm .nav-link,
        #sidenav-main[data-hovered="true"] .nav.nav-sm .nav-link {
          justify-content: flex-start !important;
          gap: 10px !important;
        }

        #sidenav-main[data-collapsed="true"] .navbar-brand {
          display: flex !important;
          align-items: center;
          justify-content: center;
          width: 100%;
          margin-left: 0 !important;
          padding-left: 0 !important;
          padding-right: 0 !important;
        }

        #sidenav-main[data-collapsed="true"] .sidenav-header {
          flex-direction: column;
          gap: 10px;
          padding-bottom: 10px;
          align-items: center !important;
        }

        #sidenav-main[data-collapsed="true"] .ml-auto {
          margin-left: 0 !important;
          width: 100%;
          display: flex;
          justify-content: center;
        }

        #sidenav-main .menu-toggle {
          width: 36px;
          height: 36px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(226, 232, 240, 1);
          border-radius: 10px;
          background: #ffffff;
          cursor: pointer;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03);
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          color: #94a3b8;
        }

        #sidenav-main .menu-toggle:hover {
          background: #f8fafc;
          border-color: #cbd5e1;
          color: #0f172a;
          box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.08), 0 4px 6px -2px rgba(0, 0, 0, 0.04);
          transform: translateY(-1px);
        }

        #sidenav-main[data-collapsed="false"] .menu-toggle,
        #sidenav-main[data-hovered="true"] .menu-toggle {
          margin-top: 14px !important;
          margin-right: 8px !important;
        }

        #sidenav-main .menu-toggle i {
          font-size: 18px;
          line-height: 1;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .menu-toggle {
          width: 44px;
          height: 44px;
          margin-top: 14px !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-link-text {
          display: none;
        }

        #sidenav-main[data-collapsed="false"] .nav-link-text,
        #sidenav-main[data-hovered="true"] .nav-link-text {
          display: inline-block !important;
          font-weight: inherit !important;
          color: inherit !important;
          opacity: 1 !important;
          visibility: visible !important;
          max-width: 200px !important;
          white-space: nowrap !important;
          text-overflow: ellipsis !important;
          overflow: hidden !important;
        }

        #sidenav-main .nav-link .nav-link-text {
          color: #1e293b !important;
          font-weight: 500 !important;
        }

        #sidenav-main .nav-link:hover .nav-link-text,
        #sidenav-main .nav-link.active .nav-link-text {
          color: #0f172a !important;
          font-weight: 500 !important;
        }

        #sidenav-main .menu-parent-link .nav-link-text {
          color: #1e293b !important;
          font-weight: 500 !important;
        }

        #sidenav-main[data-collapsed="false"] .nav.nav-sm,
        #sidenav-main[data-hovered="true"] .nav.nav-sm {
          display: flex !important;
        }

        #sidenav-main[data-collapsed="false"] .collapse.show,
        #sidenav-main[data-hovered="true"] .collapse.show {
          display: block !important;
          height: auto !important;
          visibility: visible !important;
          opacity: 1 !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav.nav-sm {
          display: none !important;
        }

        #sidenav-main[data-collapsed="true"][data-hovered="false"] .nav-link {
          position: relative;
        }
        
        #sidenav-main .sidebar-brand-mark {
          width: 44px;
          height: 44px;
          border-radius: 12px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          background: #171717;
          color: #ffffff;
          font-size: 22px;
          font-weight: 500;
          box-shadow: 0 4px 14px rgba(0, 0, 0, 0.16);
          text-shadow: 0 2px 4px rgba(0,0,0,0.1);
          border: 1px solid #171717;
        }
      `}</style>
      <div className="scrollbar-inner">
        <div className="sidenav-header d-flex align-items-start justify-content-between w-100" style={{ padding: "12px 8px", boxSizing: "border-box" }}>
          <a
            className="navbar-brand m-0 p-0"
            href="/Dashboard"
          >
            {isCollapsedRail ? (
              <span className="sidebar-brand-mark">W</span>
            ) : (
              <div className="d-flex flex-column align-items-start">
                <img
                  src="/assets/img/wflogoblack.png"
                  className="navbar-brand-img"
                  alt="Workfinity"
                />
              </div>
            )}
          </a>

          <div className="ml-auto d-flex align-items-center" style={{ height: "44px" }}>
            <button
              type="button"
              className="menu-toggle m-0"
              onClick={onToggleCollapse}
              role="button"
              aria-label={isCollapsedRail ? "Expand menu" : "Collapse menu"}
            >
              <i
                className={`fa ${isCollapsedRail ? "fa-bars" : "fa-angle-left"}`}
                aria-hidden="true"
              ></i>
            </button>
          </div>
        </div>
        <div className="navbar-inner" style={{ marginTop: "4px" }}>
          <div
            className="collapse navbar-collapse"
            id="sidenav-collapse-main"
          >
            <ul className="navbar-nav">
              {checkMenuPermission("m_1") && (
                <React.Fragment>
                  <li className="nav-item d-flex justify-content-between align-items-center mt-2">
                    <h6 className="premium-sidebar-heading w-100 mb-0">
                      <i className="fa fa-cogs mr-2"></i> {isEffectivelyExpanded ? "System Admin" : null}
                    </h6>
                  </li>
                  {checkMenuPermission("sm_1_1") && (
                    <MenuItem
                      isSelected={isSelected === "setupUser"}
                      handleClick={handleClick}
                      handleNavLinkClick={handleLinkClick}
                      menuId="setupUser"
                      menuTitle="Authorized Users"
                      imageName="fa fa-user"
                      headingVisible={true}
                      activeMenuPath={activeMenuPath}
                      subMenus={[
                        {
                          url: "/WorkflowUser",
                          name: "Main Users",
                          icon: "fa-user-circle-o",
                          isChecked: checkMenuPermission("ssm_1_1_1"),
                        },
                      ]}
                    ></MenuItem>
                  )}
                  {checkMenuPermission("sm_2_1") && (
                    <MenuItem
                      isSelected={isSelected === "mngPartner"}
                      handleClick={handleClick}
                      handleNavLinkClick={handleLinkClick}
                      menuId="mngPartner"
                      menuTitle="Manage Entities"
                      imageName="fa fa-building"
                      headingVisible={true}
                      activeMenuPath={activeMenuPath}
                      subMenus={[
                        {
                          url: "/ListSubcontractor/partner",
                          name: "Subcontractors",
                          icon: "fa-handshake-o",
                          isChecked: checkMenuPermission("ssm_1_2_1"),
                        },
                        {
                          url: "/Recruiter/partner",
                          name: "Recruiters",
                          icon: "fa-users",
                          isChecked: checkMenuPermission("ssm_2_2_1"),
                        },
                        {
                          url: "/ListCondidate/partner",
                          name: "Candidates",
                          icon: "fa-graduation-cap",
                          isChecked: checkMenuPermission("ssm_3_2_1"),
                        },
                      ]}
                    ></MenuItem>
                  )}

                </React.Fragment>
              )}
              {checkMenuPermission("m_2") && (
                <>
                  <li className="nav-item mb-2 mt-2">
                    <h6 className="premium-sidebar-heading w-100 mb-0">
                      <i className="fa fa-file-text mr-2"></i> {isEffectivelyExpanded ? "Onboarding" : null}
                    </h6>
                  </li>
                  <div className="collapse show">
                    <ul className="nav nav-sm flex-column">
                      {checkMenuPermission("sm_1_2") && (
                        <li className="nav-item hover-effect">
                          <NavLink
                            to="/ListSubcontractor/application"
                            className={({ isActive }) =>
                              `nav-link${isActive || activeMenuPath === "/ListSubcontractor/application" ? " active" : ""}`
                            }
                            style={{ paddingLeft: "10px" }}
                            onClick={() => handleLinkClick(false)}
                          >
                            <i className="fa fa-handshake-o" aria-hidden="true" style={{ minWidth: "1.2rem", color: "#94a3b8" }}></i>
                            <span className="nav-link-text">Subcontractors</span>
                          </NavLink>
                        </li>
                      )}
                      {checkMenuPermission("sm_2_2") && (
                        <li className="nav-item hover-effect">
                          <NavLink
                            to="/Recruiter/application"
                            className={({ isActive }) =>
                              `nav-link${isActive || activeMenuPath === "/Recruiter/application" ? " active" : ""}`
                            }
                            style={{ paddingLeft: "10px" }}
                            onClick={() => handleLinkClick(false)}
                          >
                            <i className="fa fa-users" aria-hidden="true" style={{ minWidth: "1.2rem" }}></i>
                            <span className="nav-link-text">Recruiters</span>
                          </NavLink>
                        </li>
                      )}
                      {checkMenuPermission("sm_3_2") && (
                        <li className="nav-item hover-effect">
                          <NavLink
                            to="/ListCondidate/application"
                            className={({ isActive }) =>
                              `nav-link${isActive || activeMenuPath === "/ListCondidate/application" ? " active" : ""}`
                            }
                            style={{ paddingLeft: "10px" }}
                            onClick={() => handleLinkClick(false)}
                          >
                            <i className="fa fa-graduation-cap" aria-hidden="true" style={{ minWidth: "1.2rem" }}></i>
                            <span className="nav-link-text">Candidates</span>
                          </NavLink>
                        </li>
                      )}
                    </ul>
                  </div>
                </>
              )}
              {checkMenuPermission("m_3") && (
                <>
                  <li className="nav-item mb-2 mt-2">
                    <h6 className="premium-sidebar-heading w-100 mb-0">
                      <i className="fa fa-money mr-2"></i> {isEffectivelyExpanded ? "Invoices" : null}
                    </h6>
                  </li>
                  {checkMenuPermission("sm_1_3") && (
                    <MenuItem
                      isSelected={isSelected === "projectRpt"}
                      handleClick={handleClick}
                      handleNavLinkClick={handleLinkClick}
                      menuId="projectRpt"
                      menuTitle="Invoices"
                      imageName="fa fa-filter"
                      activeMenuPath={activeMenuPath}
                      subMenus={[
                        {
                          url: "/ListCondidate/timelog",
                          name: "Time Logs",
                          icon: "fa-clock-o",
                          isChecked: checkMenuPermission("ssm_1_1_3"),
                        },
                        {
                          url: "/ListCondidate/invoice",
                          name: "Invoices & Payments",
                          icon: "fa-money",
                          isChecked: checkMenuPermission("ssm_2_2_3"),
                        },
                      ]}
                    ></MenuItem>
                  )}
                </>
              )}
              {checkMenuPermission("m_4") && (
                <>
                  <li className="nav-item mb-2 mt-2">
                    <h6 className="premium-sidebar-heading w-100 mb-0">
                      <i className="fa fa-bar-chart mr-2"></i> {isEffectivelyExpanded ? "Analytics" : null}
                    </h6>
                  </li>
                  {checkMenuPermission("sm_1_4") && (
                    <MenuItem
                      isSelected={isSelected === "report"}
                      handleClick={handleClick}
                      handleNavLinkClick={handleLinkClick}
                      menuId="report"
                      menuTitle="Reports"
                      imageName="fa fa-database"
                      activeMenuPath={activeMenuPath}
                      subMenus={[
                        {
                          url: "/Dashboard",
                          name: "Dashboard",
                          icon: "fa-tachometer",
                          isChecked: checkMenuPermission("ssm_1_1_4"),
                        },
                        {
                          url: "/ApplicationReport",
                          name: "Entity Data",
                          icon: "fa-database",
                          isChecked: checkMenuPermission("ssm_2_2_4"),
                        },
                        {
                          url: "/CustomReport/report",
                          name: "Business Reports",
                          icon: "fa-bar-chart",
                          isChecked: checkMenuPermission("ssm_3_3_4"),
                        },
                        {
                          url: "/CustomReport/compliance",
                          name: "Compliance Reports",
                          icon: "fa-check-square-o",
                          isChecked: checkMenuPermission("ssm_5_5_4"),
                        },
                      ]}
                    />
                  )}
                </>
              )}
              {checkMenuPermission("m_5") && (
                <>
                  <li className="nav-item mb-2 mt-2">
                    <h6 className="premium-sidebar-heading w-100 mb-0">
                      <i className="fa fa-shield mr-2"></i> {isEffectivelyExpanded ? "Security" : null}
                    </h6>
                  </li>
                  {checkMenuPermission("sm_1_5") && (
                    <MenuItem
                      isSelected={isSelected === "monitoringLogs"}
                      handleClick={handleClick}
                      handleNavLinkClick={handleLinkClick}
                      menuId="monitoringLogs"
                      menuTitle="Security"
                      imageName="fa fa-clipboard"
                      headingVisible={false}
                      activeMenuPath={activeMenuPath}
                      subMenus={[
                        {
                          url: "/MonitoringLogs",
                          name: "Monitoring Logs",
                          icon: "fa-shield",
                          isChecked: checkMenuPermission("ssm_1_1_5"),
                        },
                      ]}
                    ></MenuItem>
                  )}
                </>
              )}
              {checkMenuPermission("m_6") && (
                <>
                  <li className="nav-item">
                    <h6 className="premium-sidebar-heading w-100 mb-0">
                      <i className="fa fa-comments mr-2"></i> {isEffectivelyExpanded ? "Communications" : null}
                    </h6>
                  </li>
                  {checkMenuPermission("sm_1_6") && (
                    <MenuItem
                      isSelected={isSelected === "emailSetup"}
                      handleClick={handleClick}
                      handleNavLinkClick={handleLinkClick}
                      menuId="emailSetup"
                      menuTitle="Emails"
                      imageName="fa fa-envelope"
                      headingVisible={true}
                      activeMenuPath={activeMenuPath}
                      subMenus={[
                        {
                          url: "/PartnerEmails/mail",
                          name: "Subcontractors",
                          icon: "fa-envelope-o",
                          isChecked: checkMenuPermission("ssm_1_1_6"),
                        },
                        {
                          url: "/AgencyEmails/mail",
                          name: "Recruiters",
                          icon: "fa-envelope-open-o",
                          isChecked: checkMenuPermission("ssm_2_1_6"),
                        },
                        {
                          url: "/ApplicantEmails/mail",
                          name: "Candidates",
                          icon: "fa-envelope",
                          isChecked: checkMenuPermission("ssm_3_1_6"),
                        },
                      ]}
                    ></MenuItem>
                  )}
                  {checkMenuPermission("sm_2_6") && (
                    <MenuItem
                      isSelected={isSelected === "textSetup"}
                      handleClick={handleClick}
                      handleNavLinkClick={handleLinkClick}
                      menuId="textSetup"
                      menuTitle="Text Messages"
                      imageName="fa fa-commenting"
                      headingVisible={true}
                      activeMenuPath={activeMenuPath}
                      subMenus={[
                        {
                          url: "/PartnerEmails/text",
                          name: "Subcontractors",
                          icon: "fa-mobile",
                          isChecked: checkMenuPermission("ssm_1_2_6"),
                        },
                        {
                          url: "/AgencyEmails/text",
                          name: "Recruiters",
                          icon: "fa-comment-o",
                          isChecked: checkMenuPermission("ssm_2_2_6"),
                        },
                        {
                          url: "/ApplicantEmails/text",
                          name: "Candidates",
                          icon: "fa-comments-o",
                          isChecked: checkMenuPermission("ssm_3_2_6"),
                        },
                      ]}
                    ></MenuItem>
                  )}
                  {checkMenuPermission("sm_3_6") && (
                    <MenuItem
                      isSelected={isSelected === "surveySetup"}
                      handleClick={handleClick}
                      handleNavLinkClick={handleLinkClick}
                      menuId="surveySetup"
                      menuTitle="Surveys"
                      imageName="fa fa-list-alt"
                      headingVisible={true}
                      activeMenuPath={activeMenuPath}
                      subMenus={[
                        {
                          url: "/SurveyFeedback",
                          name: "Surveys",
                          icon: "fa-commenting-o",
                          isChecked: checkMenuPermission("ssm_1_3_6"),
                        },
                      ]}
                    ></MenuItem>
                  )}
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Menu;
